import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { DateTime } from 'luxon';
import { Valid } from 'luxon/src/_util';
import { ISchedule } from '@eon-iqe/iqe-shared-components/lib/time-slice-chart/time-slice.chart.component.type';
import { environment } from '../../../environments/environment';
import { IRowData } from '../../model/dto/rowdata.type';

@Injectable({ providedIn: 'root' })
export class EventsScheduleApiService {
    constructor(private httpClient: HttpClient) {
    }

    public getEventsSchedule(
        begin: DateTime<Valid>,
        end: DateTime<Valid>,
        type: 'AVAILABILITY',
        portfolioId: string,
        siteId: string,
    ): Observable<IRowData[]> {
        return this.httpClient.get<IRowData[]>(`${environment.backendUrl}/availability-schedule/v1`, {
            params: { type, begin: begin.toISO(), end: end.toISO(), portfolioId, siteId },
        });
    }

    public getAllAvailabilitySchedulesV1(
        begin: DateTime<Valid>,
        end: DateTime<Valid>,
        type: 'AVAILABILITY',
        portfolioId: string,
        siteId: string,
    ): Observable<ISchedule[]> {
        return this.httpClient.get<ISchedule[]>(`${environment.backendUrl}/availability-schedule/v1`, {
            params: { type, begin: begin.toISO(), end: end.toISO(), portfolioId, siteId },
        }).pipe(
            map((schedules: ISchedule[]) => schedules.filter((schedule: ISchedule) => schedule.sliceList)),
        );
    }

}
